import { Controller } from 'stimulus';
import { formatCurrency } from '@/js/shared/billables/currency';
import { decimal } from '@/js/shared/billables/decimal';

const MAX_PERCENTAGE = '100';
const MAX_CURRENCY = '999999.99';

export default class extends Controller {
  static targets = [
    'row',
    'amountRow',
    'calculatedAmount',
    'valueInput',
    'unit',
    'enabledCheckbox',
    'totalRow',
    'balanceRow',
  ];

  get calculationInput() {
    if (!this.hasValueInputTarget || !this.hasEnabledCheckboxTarget) {
      return { enabled: false, unit: null, value: '0' };
    }

    return {
      enabled: this.enabledCheckboxTarget.checked,
      unit: this.unitTargets.find((unit) => unit.checked)?.value,
      value: this.valueInputTarget.value || '0',
    };
  }

  update() {
    this.dispatch('changed');
  }

  toggle() {
    const enabled = this.enabledCheckboxTarget.checked;

    this.resetDeposit();
    this.rowTarget.classList.toggle('hide', !enabled);
    this.amountRowTarget.classList.toggle('hide', !enabled);
    this.totalRowTarget.classList.toggle('billable-totals__total--gray', enabled);

    if (this.hasBalanceRowTarget) {
      this.balanceRowTarget.classList.toggle('hide', enabled);
    }

    if (enabled) {
      this.valueInputTarget.focus();
    }
  }

  resetDeposit() {
    this.valueInputTarget.value = '0.00';
    this.#syncValueLimit();
    this.update();
  }

  renderCalculatedAmount({ deposit, total, currency }) {
    if (!this.hasValueInputTarget) {
      return;
    }

    const exceedsTotal = decimal(deposit).gt(decimal(total));

    this.calculatedAmountTarget.textContent = formatCurrency(deposit, currency);
    this.valueInputTarget.classList.toggle('field--error', exceedsTotal);
    this.valueInputTarget.setCustomValidity(
      exceedsTotal ? "Deposit can't be more than the total" : ''
    );
  }

  #syncValueLimit() {
    const selectedUnit = this.unitTargets.find((unit) => unit.checked)?.value;

    this.valueInputTarget.max = selectedUnit === 'currency' ? MAX_CURRENCY : MAX_PERCENTAGE;
  }
}
